<template>
  <div class="container page" style="background: #1f1c1f">
    <div class="header">
      <van-nav-bar :title="$t('withdraw.with_record')" class="nav-bar">
        <template #left>
          <img
            src="/img/newLogin/download.png"
            @click="back()"
            style="width: 20px; height: 15px"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="list.length === 0"
          :description="$t('withdraw.empty_data')"
        />
        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="topInfo">
            <span v-if="v.status === 2" style="color: #07c160">{{
              v.status_text
            }}</span>
            <span v-else-if="v.status === 4" style="color: #07c160">{{
              v.status_text
            }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span>{{ $t("withdraw.money") }}：-{{ v.money }}</span>
          </div>
          <div class="desc">
            <span>{{ $t("withdraw.desc") }}：{{ v.desc }}</span>
          </div>
          <div class="time">
            <span>{{ $t("jmhbdz") }}：{{ v.addr }}</span>
          </div>
          <div class="time">
            <span>{{ $t("withdraw.submit_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t("withdraw.check_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: "get",
        url: "user_get_withdraw_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserWithdrawList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  box-shadow: 0 2px 8px #000;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
}

.item_list .topInfo span:last-child {
  float: right;
}
.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }
  .nav-bar {
    height: 50px;
  }

  .main {
    padding: 10px 15px !important;
  }
  .item_list {
    margin: 15px 0 !important;
    padding: 16px;
    border-radius: 10px;
    line-height: normal;
    box-shadow: none;
    transition: all 0.2s;
  }

  .lottery_info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .item_list .period-number {
    height: 30px;
    line-height: 30px;
  }

  .item_list:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
  }

  /* 头部信息 */
  .period-number {
    font-size: 16px !important;
    margin-left: 15px !important;
  }

  .cover {
    width: 40px !important;
    height: 40px !important;
  }

  /* 每一行 */
  .recent {
    height: auto !important;
    margin: 20px 0;
  }

  .kuaisan-ball span {
    font-size: 13px;
  }

  .ressquareBox {
    height: auto !important;
    line-height: normal !important;
    font-size: 14px !important;
    padding: 4px 10px !important;
    margin-left: 8px !important;
    border-radius: 8px;

    min-width: auto !important;
  }

  .topInfo {
    margin: 10px 0;
  }

  /* 状态+金额 */
  .topInfo span {
    font-size: 18px !important;
    font-weight: 700 !important;
    color: #f3c7a2;
  }
  .item_list .time {
    margin: 10px 0;
  }

  /* 时间 */
  .time span {
    font-size: 14px !important;
    color: #f3c7a2;
  }

  .item_list .desc span {
    font-size: 14px;
  }
}
</style>
